<script>
import {sync} from "vuex-pathify";

export default {
    props: {
        gifts: Object,
    },
    computed: {
        selectedGiftId: sync('form_data/gift'),
    },
}
</script>

<template>
    <div>
        <select v-model="selectedGiftId" name="gift" id="gift_choice" class="gift-choice__dropdown">
            <option :value="null" >Kies je cadeau</option>
            <option v-for="(gift, giftId) in gifts" :value="giftId">{{gift}}</option>
        </select>
    </div>
</template>
